/*
     Title: Sample Type API
     Description: Sample Type API
     Author: Iqbal Hossain
     Date: 09-January-2022
     Modified: 09-January-2022
*/

export const SAMPLE_TYPE_API = {
  root: '/api/sample-type',
  fetch_all: 'api/sample-type/fetch-all',
  fetch_by_query: `/api/sample-type/fetch-by-query`,
  fetch_by_id: `/api/sample-type/fetch-by-id`,
  add: `/api/sample-type/add`,
  update: `/api/sample-type/update`,
  delete: `/api/sample-type/delete`,
  delete_by_range: `/api/sample-type/delete-range`
};
